/* istanbul ignore file */
import { gql } from '@apollo/client';

export const ASSIGN_ROLES_TO_USER_MUTATION = gql`
  mutation AssignRolesToUserMutation($input: AssignRolesToUserInput!) {
    assignRolesToUser(input: $input) {
      roleIds
      userId
    }
  }
`;
